// extracted by mini-css-extract-plugin
module.exports = {"cornerSprite":"style__cornerSprite__ew-sH","sideSprite":"style__sideSprite__NgAnm","middleSprite":"style__middleSprite__rG6vN"};